import * as React from "react";
import { useState } from 'react';
import {
    List,
    Datagrid,
    TextField,
    ShowButton,
    CardActions,
    CreateButton,
    FunctionField,
} from 'react-admin';
import EmployeeActionButton from '../component/EmployeeActionButton';
import EmployeeEditButton from '../component/EmployeeEditButton';
import {Button, Box, Typography, Dialog, DialogContent, DialogContentText, DialogActions} from "@material-ui/core";
import errorMessage from "../helper/ErrorMessage";
import Filter from './Filter';

const rowStyle = (record) => ({
    backgroundColor: record.status && record.status === 'APPROVED' ? 'white' : '#ffbbbb',
});

const translateForType = {
    OWNER: "Керівник закладу ОЗ",
    PHARMACIST: "Фармацевт",
    PHARMACY_OWNER: "Керівник аптеки",
    HR: "Відділ кадрів",
    RECEPTIONIST: "Реєстратор",
    PROVISOR: "Загальна фармація",
    CLINICAL_PROVISOR: "Клінічна фармація"
}

const translateForStatus = {
    APPROVED: "Активний",
    REJECT: "Звільнений",
    NEW: "Новий"
}

export const EmployeeList = (props) => {
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [confirmOpen, setConfirmOpen] = useState(false);

    const popupAlert = (message) => {
        setAlertOpen(true);
        setAlertText(message);
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    const handleConfirmOpen = () => {
        setConfirmOpen(true);
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const handleSave = () => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                'X-Session': localStorage.getItem('session')
            }
        };

        fetch(
            process.env.REACT_APP_BASE_ENTRYPOINT + '/employee/sync',
            requestOptions
        )
            .then(response => {
                if (response.status >= 400) {
                    return Promise.reject();
                }

                return response.json();
            })
            .then(data => {
                if (data.success) {
                    popupAlert('Синхронізація БД запущена');
                    handleConfirmClose();
                } else {
                    errorMessage(data, popupAlert);
                }
            })
            .catch(() => {popupAlert('Помилка надсилання запиту');});
    }

    const EmployeeActions = ({
                                 bulkActions,
                                 basePath,
                                 currentSort,
                                 displayedFilters,
                                 exporter,
                                 filters,
                                 filterValues,
                                 onUnselectItems,
                                 resource,
                                 selectedIds,
                                 showFilter,
                                 total
                             }) => (
        <CardActions>
            {bulkActions && React.cloneElement(bulkActions, {
                basePath,
                filterValues,
                resource,
                selectedIds,
                onUnselectItems,
            })}
            {filters && React.cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            }) }
            <CreateButton basePath={basePath} label={"Створити"} />
            <Box component="span" ml={2}>
                <Button color={"primary"} onClick={handleConfirmOpen}>Актуалізувати з БД</Button>
            </Box>

            <Dialog
                open={confirmOpen}
                onClose={handleConfirmClose}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="confirm-dialog-content">
                        Після підтвердження дані співробітників вашої компанії будуть синхронізовані з БД Подорожника.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSave} variant="contained" color="primary">Добре</Button>
                    <Button onClick={handleConfirmClose} variant="contained">Відхилити</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={alertOpen}
                onClose={handleAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-content">
                        {alertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAlertClose} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </CardActions>
    );

    const Empty = () => {
        return (
            <Box textAlign="center" m={1}>
                <Typography variant="h4" paragraph>
                    Мої співробітники - відсутні
                </Typography>
            </Box>
        );
    };

    return (
        <List {...props}
              filters={<Filter />}
              bulkActionButtons={false}
              perPage={25}
              title="Мої співробітники"
              actions={<EmployeeActions/>}
              className="list-styles"
              empty={<Empty/>}
        >
            <Datagrid rowStyle={rowStyle}>
                <TextField label="Прізвище" source="party.lastName"/>
                <TextField label="Iм'я" source="party.firstName"/>
                <TextField label="По батькові" source="party.secondName"/>
                <FunctionField
                    label="Тип"
                    render={record => `${translateForType[record.employeeType]}`}
                />
                <FunctionField
                    label="Статус"
                    render={record => `${record.status ? translateForStatus[record.status] : ''}`}
                />
                <TextField label="Аптека" source="division.name"/>
                <ShowButton label={"Переглянути"}/>
                <EmployeeEditButton label={"Редагувати"}/>
                <EmployeeActionButton/>
            </Datagrid>
        </List>
    );
};

export default EmployeeList;
